import { useTranslation } from 'react-i18next'
import { BriefingGuidanceCollapsible } from '@/shared/briefing/BriefingGuidanceCollapsible'
import { V2RohsProductComplianceFilesSection } from '@/v2/components/V2RohsProductComplianceFilesSection'
import type { RohsBriefingStep } from '../../utils/rohsLegislationBriefing'
import { V2RohsLegislationBriefingStepShell } from './V2RohsLegislationBriefingStepShell'

function PartEvidenceSnapshot() {
  const { t } = useTranslation('common')
  const snapshotBase =
    'v2.pages.products.detail.rohsBriefing.steps.items.partEvidence.snapshot'
  const snapshotItems = t(`${snapshotBase}.items`, { returnObjects: true })

  return (
    <BriefingGuidanceCollapsible
      idPrefix='part-evidence-snapshot'
      title={t(`${snapshotBase}.title`)}
      intro={t(`${snapshotBase}.intro`)}
      items={Array.isArray(snapshotItems) ? snapshotItems.filter((item) => typeof item === 'string') : []}
    />
  )
}

export function V2RohsPartEvidenceStep({
  step,
  index,
  productId,
  rohsApplies,
}: {
  step: RohsBriefingStep
  index: number
  productId: string
  rohsApplies: boolean
}) {
  return (
    <V2RohsLegislationBriefingStepShell step={step} index={index}>
      <PartEvidenceSnapshot />
      <V2RohsProductComplianceFilesSection
        productId={productId}
        rohsApplies={rohsApplies}
        embedded
        collapsible
      />
    </V2RohsLegislationBriefingStepShell>
  )
}
